import { deserializeURLSearchParams, validateParams } from "@/lib/utils";
import { usePathname, useRouter, useSearchParams } from "next/navigation";
import { useCallback } from "react";
import z from "zod";

const draftsFiltersSchema = z.object({
  q: z.string().optional(),
  p: z.coerce.number().int().positive().optional(),
  s: z.coerce.number().int().positive().optional(),
});

export function useDraftsFilters() {
  const searchParams = useSearchParams();
  const pathname = usePathname();
  const router = useRouter();

  const parsed = validateParams(
    draftsFiltersSchema,
    deserializeURLSearchParams(searchParams.toString()),
  );

  const q = parsed.q;
  const p = parsed.p ?? 1;
  const s = parsed.s ?? 10;

  const setFilters = useCallback(
    (next: Partial<{ q?: string; p?: number; s?: number }>) => {
      const params = new URLSearchParams(searchParams);

      if ("q" in next) {
        if (next.q) {
          params.set("q", next.q);
        } else {
          params.delete("q");
        }
        params.set("p", "1");
      }

      if (next.p !== undefined) {
        if (next.p > 1) {
          params.set("p", String(next.p));
        } else {
          params.delete("p");
        }
      }

      if (next.s !== undefined) {
        if (next.s !== 10) {
          params.set("s", String(next.s));
        } else {
          params.delete("s");
        }
      }

      router.replace(`${pathname}?${params.toString()}`, { scroll: false });
    },
    [pathname, router, searchParams],
  );

  return {
    q,
    p,
    s,
    setFilters,
  };
}
